import React from 'react'
import {
  ListItem,
  Typography,
  Slider,
  makeStyles,
  withStyles,
  Button,
  Theme
} from '@material-ui/core'
import { useInjuries } from '../../providers/InjurySimulation'
import { KelmanDraggable, KelmanDraggableInjury } from '@phaco3d/kelman'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%'
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'left',
    alignItems: 'flex-start',
    '&.MuiListItem-root': {
      paddingTop: 5,
      paddingBottom: 5,
      color: '#fff',
      fontSize: '11px'
    },
    '&.MuiListItem-gutters': {
      paddingLeft: 12,
      padingRight: 12
    }
  },
  text: {
    '&.MuiTypography-caption': {
      fontSize: '11px'
    }
  },
  activeBtn: {
    '&.MuiButton-root:hover': {
      background: theme.palette.primary.light
    },
    '&.Mui-disabled': {
      background: theme.palette.primary.dark,
      color: 'white'
    }
  }
}))

const CustomSlider = withStyles({
  root: {
    '&.MuiSlider-root': {
      padding: '13px 0'
    }
  }
})(Slider)

type Diseases = {
  id: string
  name: string
  min: number
  max: number
  step: number
  defaultValue: number
}

interface SliderProps {
  diseases: Diseases[]
}

const SliderDiseases: React.FC<SliderProps> = ({ diseases }) => {
  const [eyeImage, setEyeImage] = React.useState<string>('/od.png')
  const classes = useStyles()

  const getValue = (value: number) => {
    return `${value}`
  }

  const { handleChangeInjury, injuries } = useInjuries()

  return (
    <div className={classes.root}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button
          color="primary"
          variant="contained"
          disabled={eyeImage === '/od.png'}
          className={classes.activeBtn}
          onClick={() => setEyeImage('/od.png')}
        >
          OD
        </Button>
        <Button
          color="primary"
          variant="contained"
          disabled={eyeImage === '/oe.png'}
          className={classes.activeBtn}
          onClick={() => setEyeImage('/oe.png')}
        >
          OE
        </Button>
      </div>
      <KelmanDraggableInjury
        eyeImage={eyeImage}
        eyeContainer={{
          height: '280px',
          width: '100%',
          position: 'relative',
          overflow: 'hidden',
          padding: '0'
        }}
      >
        {injuries &&
          injuries[0] !== undefined &&
          injuries.map(injury => {
            if (!injury.active) {
              return ''
            }
            return (
              <KelmanDraggable
                key={injury.name}
                bounds="parent"
                position={{ x: 100, y: 100 }}
                onDrag={(e, position) => {
                  return injury.onInjuryDrag(e, position)
                }}
              >
                <div style={injury.lesion} />
              </KelmanDraggable>
            )
          })}
      </KelmanDraggableInjury>
      {diseases.map(disease => {
        return (
          <ListItem key={disease.id} className={classes.item}>
            <Typography
              id={disease.name}
              className={classes.text}
              variant="caption"
              color="inherit"
            >
              {disease.name}
            </Typography>
            <CustomSlider
              getAriaValueText={getValue}
              aria-labelledby="discrete-slider"
              valueLabelDisplay="auto"
              marks
              onChange={(_, value) => {
                if (handleChangeInjury) {
                  handleChangeInjury(disease.id, `${value}`)
                }
              }}
              id={disease.name}
              defaultValue={disease.defaultValue}
              min={disease.min}
              max={disease.max}
              step={disease.step}
            />
          </ListItem>
        )
      })}
    </div>
  )
}

export default SliderDiseases
